import { ReactNode } from 'react'
import { Pressable, StyleSheet, View } from 'react-native'
import { Icon, Text } from 'react-native-paper'
import { useTheme } from '../../../../../hooks/theme.hook'
import { useWindowDimensions } from 'react-native'

interface ClusterHeaderButtonProps {
  icon: string | ReactNode
  onPress: () => void
  children: string
  variant?: 'primary' | 'secondary'
}

export function ClusterHeaderButton({
  icon,
  onPress,
  children,
  variant = 'primary',
}: ClusterHeaderButtonProps) {
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const backgroundColor =
    variant === 'secondary' ? theme.colors.surface : theme.colors.primary
  const textColor =
    variant === 'secondary' ? theme.colors.primary : theme.colors.onPrimary
  const borderColor =
    variant === 'secondary' ? theme.colors.primary : 'transparent'
  const borderWidth = variant === 'secondary' ? 1 : 0

  const styles = StyleSheet.create({
    button: {
      backgroundColor,
      borderColor,
      borderWidth,
      borderRadius: 20,
      paddingHorizontal: theme.spacing(1.5),
      paddingVertical: theme.spacing(0.5),
      minHeight: 32,
      justifyContent: 'center',
      alignItems: 'center',
    },
    buttonPressed: {
      opacity: 0.8,
    },
    content: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    label: {
      color: textColor,
      fontSize: width > 480 ? 14 : 12,
    },
  })

  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => [styles.button, pressed && styles.buttonPressed]}
    >
      <View style={styles.content}>
        {typeof icon === 'string' ? (
          <Icon source={icon} size={16} color={textColor} />
        ) : (
          icon
        )}
        <Text variant="labelMedium" style={styles.label}>
          {children}
        </Text>
      </View>
    </Pressable>
  )
}
